<div *ngIf="reportType == 'PendingCommReport'">
    
    <div class="container" id="print-section">
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th colspan="5">हिंदुस्तान प्रकाशन संस्था - विवेक साप्ताहिक</th>
                    <!-- <th colspan="2">Advt. Outstanding Report</th> -->
                    <th colspan="2">दिनांक : {{ today | date:'dd/MM/yyyy' }}</th>
                    <th colspan="1">पृष्ठ क्र :-1</th>
                </tr>
                <tr>
                    <th colspan="5">अंकाचे नाव</th>
                    <!-- <th colspan="1">Date : {{today}}</th> -->
                    <th colspan="2">From -{{startDate | date:'dd/MM/yyyy'}}</th>
                    <th colspan="1">To-{{endDate | date:'dd/MM/yyyy'}}</th>
                    <!-- <th colspan="2">All Advt List</th>
                    <th colspan="1">In Details</th> -->
                </tr>
                <tr>
                    <th colspan="1">Invoice No</th>
                    <th colspan="1">Invoice Date</th>
                    <th colspan="1">Advt Name </th>
                    <!-- <th colspan="1">Contact No</th> -->
                    <th colspan="1">Issue Name</th>
                    <th colspan="1">Issue Date</th>
                    <th colspan="1">Net Amt</th>
                    <th colspan="1">Pending Amount</th>
                    <th colspan="1">Received Amount</th>
                    <!-- <th colspan="1">Paid Commission Amount</th> -->
                    <!-- <th colspan="1">Selected For Commission</th> -->
                    <!-- <th colspan="1">Selected Amount</th> -->
                </tr>   
            </thead>
            <!-- *ngFor="let data of OutstandingInDetailFormBeans; let i = index" -->
           <tbody *ngFor="let data of getpaiddata; let i = index">
    <tr>
        <td colspan="4" style="font-weight: bold; font-size: 16px;">Representative Name</td>
        <td colspan="3" style="font-weight: bold; font-size: 16px;">{{data.rep_name}} </td>
    </tr>

    <ng-container *ngFor="let data1 of data.rep_data; let j = index">
        <tr>
            <td colspan="1">{{data1.advt_invoice_no}}</td>
            <td colspan="1">{{data1.advt_invoice_date}}</td>
            <td colspan="1" style="text-align:left;">{{data1.advt_name}}</td>
            <td colspan="1" style="text-align:left;">{{data1.DS_ISSUENAME}}</td>
            <td colspan="1">{{data1.DS_ISSUEDATE}}</td>
            <td colspan="1" style="text-align: right;">{{data1.net_amount}}</td>
            <td colspan="1" style="text-align: right;">{{data1.pending_amt}}</td>
            <td colspan="1" style="text-align: right;">{{data1.rcv_amt}}</td>
            <!-- <td colspan="1">{{data1.com_amt}}</td> -->
            <!-- <td colspan="1">{{data1.com_paid_date}}</td> -->
            <!-- <td colspan="1">{{data1.credit_amt}}</td> -->
        </tr>
    </ng-container>

    <tr>
        <td colspan="5" style="font-weight: bold;font-size: 16px;">Total:</td>
        <td colspan="1" style="font-weight: bold;font-size: 16px;text-align: right;">{{data.net_total}}</td>
        <td colspan="1" style="font-weight: bold;font-size: 16px;text-align: right;">{{data.pending_total}}</td>
        <td colspan="1" style="font-weight: bold;font-size: 16px;text-align: right;">{{data.rcv_amt}}</td>
        <!-- <td colspan="1" style="font-weight: bold;font-size: 16px;"></td> -->
        <!-- <td colspan="1" style="font-weight: bold;font-size: 16px;"></td> -->
        <!-- <td colspan="1" style="font-weight: bold;font-size: 16px;"></td> -->
    </tr>
</tbody>


            <tfoot>
                <!-- <tr>
                    <td colspan="6" style="font-weight: bold; font-size: 16px;">Total:</td>
                    <td colspan="1" style="font-weight: bold; font-size: 16px;">Rs-{{  }}</td>
                    <td colspan="1" style="font-weight: bold; font-size: 16px;">Rs-{{  }}</td>
                    <td colspan="1" style="font-weight: bold; font-size: 16px;">Rs-{{ j kk}}</td>
                </tr> -->
              
              </tfoot>  
        </table>
       
    </div>

    <div style="margin-left: 80%; margin-bottom: 2%;">
           
            <button class="noPrint" style="margin-top: 2%; margin-left: 2%"
                (click)="exportExcel('Contract_InDetails_Report')" mat-raised-button color="primary">
                Export
            </button>

            <button class="noPrint" style="margin-top: 2%;" mat-raised-button color="primary"
               [useExistingCss]="true"
                printSectionId="print-section" ngxPrint>
                print
            </button>
            
            <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
                Close
            </button>
        </div>
</div>